<template>
  <div>

    <loading :active.sync="isLoading" opacity="0.9"></loading>
    <div class="row">
      <div class="col-md-12">

        <KTCodePreview class="px-10" v-bind:title="$t('KYBData')">
          <template v-slot:preview>

            <!--col-md-3-->
            <div class="">
              <b-form-group class="d-inline-flex pb-3" label-for="filter-input" label-cols-sm="0" label-size="sm">
                <b-input-group size="sm">
                  <label class="mr-2 mb-0 vertical-center">{{ $t("KYBApplicants") }}</label>
<!--                    <b-form-input style="min-width: 100px;" id="filter-input" v-model="companyName" @keyup="selectedCompanyName" type="search" placeholder="Search by company name."></b-form-input>-->
                  <b-form-input
                      class="d-inline-block"
                      style="min-width: 200px;"
                      id="filter-input"
                      v-model="selectedCompanyName"
                      :placeholder="$t('SearchByCompanyName')"
                  ></b-form-input>

                  <!--
                  <b-input-group-append>
                    <b-button>
                      <b-icon class="font-weight-bolder" icon="search" ></b-icon>
                    </b-button>
                  </b-input-group-append>
                  -->
                </b-input-group>
              </b-form-group>


              <b-form-group class="d-inline-flex ml-5" label-for="filter-input" label-cols-sm="0" label-size="sm">
                <b-input-group size="sm">
                  <label class="mr-2 mb-0 vertical-center">{{ $t("Country") }}</label>
                  <b-form-input
                      class="d-inline-block"
                      style="min-width: 200px;"
                      id="filter-input"
                      v-model="searchCountry"
                      placeholder=""
                  ></b-form-input>
                </b-input-group>
              </b-form-group>


              <b-form-select style="width:250px;" class="d-inline-flex ml-5" v-model="searchAmlResult" :options="optionAmlResult"></b-form-select>
            </div>

              <transition name="fade">
                  <SubmissionTable :submissions="searchSubmissions"></SubmissionTable>
              </transition>


          </template>

          <!--
                    <template v-slot:html>
                        {{ code4.html }}
                    </template>
                    <template v-slot:js>
                        {{ code4.js }}
                    </template>
                    -->
        </KTCodePreview>
      </div>
    </div>
  </div>
</template>

<script>
import KTCodePreview from "@/view/content/CodePreview.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

import SubmissionTable from "@/view/components/table/SubmissionTable";
import countryList from '@/core/config/country.js';

export default {
  data() {
    return {

      searchCountry: "",  //검색국가

      optionAmlResult : [
        { value: null, text: this.$t("PleaseSelectAMLResult")},
        { value: 'Red Flag', text: this.$t("RedFlags") },
        { value: 'No Matches', text: this.$t("NoMatches") },
      ],
      searchAmlResult : null,   //aml결과로 검색

      isLoading : false,
      currentUser: {},
      companyName : "",
      timer : null,
      userVisibleSubmissions: [],
      selectedCompanyName: null,
      submissions: []
    };
  },
  computed: {

    searchSubmissions () {

      let vueobj = this;
      let submissions = this.submissions;

      let searchCountry = this.searchCountry;

      let countryArray = countryList.filter( (country) => {
        let countryName = country.name || "";
        let countryValue = country.value || "";
        return countryName.toUpperCase().includes( searchCountry?.toUpperCase() ) ||
            countryValue.toUpperCase().includes( searchCountry?.toUpperCase() )
      });
      let countryValues = countryArray.map( function(item) {
        return item['value'];
      } );

      let result = [];

      console.log( "before filter ::", submissions )
      result = submissions.filter(function(element) {
        let companyName = element.companyName || "";
        return ( !vueobj.searchAmlResult || element.aml_screen === vueobj.searchAmlResult ) &&
            ( !searchCountry || countryValues.includes( element.country ) ) &&
            ( !vueobj.selectedCompanyName || companyName.toLowerCase().indexOf( vueobj.selectedCompanyName.toLowerCase() ) > -1)
      })

      console.log( "result !??!?!", result )

      return result;

    }
      // submissions () {
      //     return this.$store.getters.getSubmissions;
      // },
  },
  components: {
    KTCodePreview,
    SubmissionTable
  },

  async mounted() {

    await this.$store.dispatch(SET_BREADCRUMB, [
      /*
                { title: "Vuetify", route: "alerts" },
                { title: "Tables", route: "simple-tables" },
                */
      { title: "KYB Data" }
    ]);

    /**
     * submission list 채워줌
     */
    // this.callApi();
    let projectId = this.$store.getters.getSelectedProjectId;
    console.log("projectId", projectId);

    this.isLoading = true;

    try {
      this.submissions = await this.$store.dispatch('callSubmissionList', {
        projectId: projectId,
      } );
      this.userVisibleSubmissions = this.submissions;
      console.log("this.submissions", this.submissions);
    }
    catch(e) {
      console.log("get submission List error", e);
    }
    finally {
      this.isLoading = false;
    }
  },
  watch: {
      "$i18n.locale": {
        handler() {
          this.optionAmlResult = [
            { value: null, text: this.$t("PleaseSelectAMLResult")},
            { value: 'Red Flag', text: this.$t("RedFlags") },
            { value: 'No Matches', text: this.$t("NoMatches") },
          ]
        },
      },
    selectedCompanyName: function(value){
      if(!value) {
        this.userVisibleSubmissions = this.submissions;
        return;
      }
      this.userVisibleSubmissions = (this.submissions).filter(function(element) {
        let companyName = element.companyName || "";
        return (companyName.toLowerCase().indexOf(value.toLowerCase()) > -1)
      });
    },
  },


  methods: {
    /*
    callApi () {
        let projectId = this.$session.get( this.$store.state.sessionKey.SELECTED_PROJECT_ID );
        this.$store.dispatch('callSubmissionList', {
            projectId: projectId,
        } );
    },
    */

      // selectedCompanyName (value) {
      //   console.log("value", value);
      //
      //     // clearTimeout( this.timer );
      //     // let callback = this.callApi;
      //     // this.timer = setTimeout(function() {
      //     //     // do something with input
      //     //     callback();
      //     // }, 500);
      // },

    getColor(status) {
      if ("approved" == status) return "green";
      return "orange";
    }
  }
};
</script>

<style scoped>
  .vertical-center {
    display: flex;
    align-items: center;
  }

  .fade-enter-active, .fade-leave-active {
      transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
      opacity: 0;
  }

</style>
